// extracted by mini-css-extract-plugin
module.exports = {"section":"SignUpHeaderSection-section_57a3f736","back":"SignUpHeaderSection-back_87364c4f","title":"SignUpHeaderSection-title_256e973c"};